module.exports = __webpack_public_path__ + "img/menu-bar-off_01.704d364e.png";